import React from 'react';
import { connect } from 'react-redux';
import * as uiActions from '@/redux/modules/ui';

import SideMenu from './SideMenu';
import ArrowLeft from '@/icons/ArrowLeft';
import imgLogo from './../../../../assets/codeCenter/logo2x.png'

@connect(
  (state) => { 
    return { sidebarStatus: state.ui.sidebarStatus }
  },
  (dispatch) => {
    return {
      toggleSidebar: () => {dispatch(uiActions.toggleSidebar())} 
    }
  }
)
class Sidebar extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    
  }
  
  render() {
    const { sidebarStatus, toggleSidebar } = this.props;

    return (
      <div className="sidebar">
        {
          !sidebarStatus ? '' :
          <div className="qc-menu-fold qc-menu-fold-left" onClick={() => { toggleSidebar(); }}>
            <ArrowLeft className="menu-arrow" width="16" height="16" />
          </div>
        }
        <img className="head-titleImg" src={imgLogo}/>
        {/* <h2 className="headline">
          <span className="head-title">剑南春优码系统</span>
        </h2> */}

   
        <SideMenu ></SideMenu>
        
      </div>
    );
  }
}

export default Sidebar; 